import router from "@/core/common/router";
import { queryPost } from "@/core/service/api";
// import { checkLoginIn } from "../service/api";

const standardtable = {
  namespaced: true,
  name: "exchangeEecord",
  state: {
    code: -1,
    loading: false
  },
  mutations: {
    changeState(state, { payload }) {
      Object.assign(state, payload);
    }
  },
  actions: {
    async history({ commit }, { payload }) {
      const response = await queryPost(payload, "/isg-projectapplication/gift/exchange/history");
      return response;
    }
  }
};

export default standardtable;
